<template>
    <v-container class="container-custom">
        <div v-if="loading" class="d-flex align-center justify-center container">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
        </div>
        <v-container class="container-custom" v-else>
            <Breadcrumbs :title="'Facturas'" size="sm"></Breadcrumbs>
            <div class="container">
                <v-row>
                    <v-col sm="8">
                        <div class="d-flex flex-wrap align-start justify-lg-space-between my-2">
                            <v-card outlined v-for="(billGroup, index) in groupedBills" class="pa-5 bill-card ma-1"
                                :elevation="0" :key="`bill-${index}`">
                                <div class="d-block">
                                    <h1 class="body-1 font-weight-bold ma-0">{{ `${billGroup.studentCareerId}` }}</h1>
                                    <template v-if="billGroup.bills.length > 0">
                                        <v-divider />
                                        <v-list class="files-list">
                                            <v-list-item v-for="(item, i) in billGroup.bills" :key="i">
                                                <v-container>
                                                    <v-row>
                                                        <v-icon color="" size="60">mdi-file</v-icon>
                                                        <v-list-item-content>
                                                            <div class="d-flex align-center caption font-weight-bold">
                                                                <v-icon class="ml-1 mr-1" color="primary" size="30"
                                                                @click="downloadFile(item, false)">mdi-cloud-download-outline</v-icon>
                                                            </div>
                                                        </v-list-item-content>
                                                        <v-spacer></v-spacer>
                                                        <v-spacer></v-spacer>
                                                        <v-icon color="blue" size="60">mdi-file</v-icon>
                                                        <v-list-item-content>
                                                            <div class="d-flex align-center caption font-weight-bold">
                                                                <v-icon class="ml-1 mr-1" color="primary" size="30"
                                                                @click="downloadFile(item, true)">mdi-cloud-download-outline</v-icon>
                                                            </div>
                                                        </v-list-item-content>
                                                    </v-row>
                                                    <v-row>
                                                        <p>Factura</p>
                                                        <v-spacer></v-spacer>
                                                        <p>Recibo</p>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item>
                                        </v-list>
                                    </template>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-container>
</template>
  
<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import { mapGetters } from 'vuex'
import { $invoice, $invoices } from '../services';


export default {
    name: 'BillsList',
    components: {
        Breadcrumbs
    },
    data() {
        return {
            studentCareers: [],
            groupedBills: [],
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            studentId: 'commons/getStudentId',
            studentData: 'commons/getStudentData',
            studentUserId: 'commons/getStudentUserID'
        }),
    },
    mounted() {
        this.initialize()
    },
    methods: {
        async initialize() {
            this.loading = true;
            const invoices = await $invoices.getInvoicesByMail(this.studentData.student.user.userData.email)
            this.getBills(invoices)
            this.studentCareers.push(this.studentData.career)
            this.loading = false;
        },
        getBills(invoices) {
            const groupedBills = Object.values(invoices.data.reduce((acc, bill) => {
                const { studentCareerId, ...rest } = bill;
                if (!acc[studentCareerId]) {
                    acc[studentCareerId] = {
                        studentCareerId,
                        bills: [],
                    };
                }
                acc[studentCareerId].bills.push(rest);
                return acc;
            }, {}));
            this.groupedBills = groupedBills;
        },
        async downloadFile(item, asReceipt) {
            const invoice = await $invoice.getInvoiceById(item.id, asReceipt)
            if (invoice) {
                const link = document.createElement('a')
                link.href = invoice.data
                link.click();
            }
        }
    }
}
</script>
  
<style lang="sass" scoped>
  
  .files-list
  .v-list-item
    min-height: 0
    font-size: 0.9em
    font-weight: bold
    overflow: hidden
    text-overflow: ellipsis
    color: #aaa !important

  .bill-card
    width: 49%
    min-height: 300px
    transition: .5s

  @media screen and (max-width: 768px)
    .bill-card
      width: auto
  </style>
  